export class StringUtils {
}
StringUtils.stringFormat = (str, ...args) => {
    if (args.length) {
        var t = typeof args[0];
        var key;
        var fargs = ("string" === t || "number" === t) ? Array.prototype.slice.call(args) : args[0];
        for (key in fargs) {
            str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), fargs[key]);
        }
    }
    return str;
};
